export * from './get-window';
